import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { MODALITIES, PAGE_BANNERS } from "../data/content";

export default function Modalities() {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.medicine} alt="Modalities" fallbackKey="medicine" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>Modalities Used at Nourish Natural Health Clinic</h1>

          <h2 className="!text-2xl tracking-wider uppercase border-b border-[#d6dcb6] pb-2">Naturopathic</h2>
          {MODALITIES.naturopathic.map((m) => (
            <section key={m.name}>
              <h3>{m.name}</h3>
              <p>{m.text}</p>
            </section>
          ))}

          <h2 className="!text-2xl tracking-wider uppercase border-b border-[#d6dcb6] pb-2">Chinese Medicine</h2>
          {MODALITIES.chinese.map((m) => (
            <section key={m.name}>
              <h3>{m.name}</h3>
              <p>{m.text}</p>
            </section>
          ))}
        </article>
      </div>
    </div>
  );
}
